// extracted by mini-css-extract-plugin
export default {"fav":"fav__78SF-"};